/// <amd-module name="Wit/DeliveryPlans/Common/Utils/PermissionUtils" />

import { PlanUserPermissions } from "Wit/Clients/Work/Contracts/Work";

export function hasPermission(userPermissions: PlanUserPermissions, requestedPermission: PlanUserPermissions): boolean {
    return (userPermissions & requestedPermission) === requestedPermission;
}
